import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router/dom'
import '@/lib/env' // validate config before anything renders
import { ThemeProvider } from '@/app/providers/ThemeProvider'
import { createQueryClient } from '@/app/queryClient'
import { createRouter } from '@/app/router'
import { authStore } from '@/features/auth/store'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import './index.css'

const queryClient = createQueryClient()
authStore.bootstrap() // restore the session from the refresh cookie (non-blocking)
const router = createRouter()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster richColors closeButton />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
